import React from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent
} from "@material-ui/core";

import {
  addBackupCreatives,
  addDcmCreatives,
  removeCreative
} from "../../../actions/app/creatives";
import CreativeList from "../../CreativeList/CreativeList";

export default function CreativeDialog({
  open,
  setOpen,
  creativeTypes,
  selectedCreatives,
  setSelectedCreatives,
  placements,
  selectedIds,
  deselectCards,
  handleCloseMenu,
  backup
}) {
  let dispatch = useDispatch();
  const bartCreatives = useSelector((state) => state.creatives);

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleAssign = () => {
    handleCloseDialog();
    handleCloseMenu();
    let creative = selectedCreatives[0];
    let backupCreative = {
      file: creative,
      size: `${creative.size.width} x ${creative.size.height}`,
      weight: 0
    };
    dispatch(addBackupCreatives(selectedIds, backupCreative));
    deselectCards();
  };

  const handleSelect = () => {
    handleCloseDialog();

    let selectedCreativeIds = selectedCreatives.map((c) => c.id);

    let dcmIdsInBart = Object.values(bartCreatives.byId).map(
      (bartCreatives) => bartCreatives.dcmId
    );

    let creativesToAdd = selectedCreatives.filter(
      (dcmCreative) => !dcmIdsInBart.includes(dcmCreative.id)
    );

    let creativesToRemove = Object.values(bartCreatives.byId).filter(
      (bartCreative) => {
        if (bartCreative.dcmId) {
          return !selectedCreativeIds.includes(bartCreative.dcmId);
        } else {
          return false;
        }
      }
    );

    for (let i = 0; i < creativesToRemove.length; i++) {
      dispatch(removeCreative(creativesToRemove[i].id));
    }

    dispatch(addDcmCreatives(creativesToAdd));
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
      >
        <DialogContent>
          <CreativeList
            creativeTypes={creativeTypes}
            selectedCreatives={selectedCreatives}
            setSelectedCreatives={setSelectedCreatives}
            placements={placements}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary" disableElevation>
            Cancel
          </Button>
          {backup ? (
            <Button
              onClick={handleAssign}
              color="primary"
              autoFocus
              disableElevation
            >
              Assign
            </Button>
          ) : (
            <Button
              onClick={handleSelect}
              color="primary"
              autoFocus
              disableElevation
            >
              Select
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
